import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycWillsAndTrustsLastWillAndTestamentInNewYorkPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-wills-and-trusts/last-will-and-testament-in-new-york/']} />;
}
